import React, { useState, useEffect, Suspense, lazy } from 'react';
import Container from 'react-bootstrap/Container';
import "../style/blog.css";
import MenuPrincipal from "../components/menuPrincipal";
import WhatsApp from "../components/whatsApp";
import { useParams } from 'react-router-dom';
import api from '../redux/actions/configApi';
import LoadingOverlay from "../components/loading";
import Rodape from '../components/rodape';
const Seo = lazy(() => import('../components/SEO'));

const Blog = () => {
  const { slug } = useParams();

  const [loading, setLoading] = useState(false); // Estado de carregamento

  console.log(slug, 'slug')
  const [article, setArticle] = useState(null);
  const [dataFormat, setDataFormt] = useState(null);
  const BASE_URL = process.env.REACT_APP_BASE_URL

  const [currentUrl, setCurrentUrl] = useState('');

  useEffect(() => {
    setCurrentUrl(window.location.href);
    const fetchArticle = async () => {
      try {
        setLoading(true)
        const response = await api.get(`noticia/${slug}`);
        setArticle(response.data);
        setLoading(false)
      } catch (error) {
        console.error('Erro ao buscar a notícia:', error);
      }
    };

    fetchArticle();
  }, [slug]);

  useEffect(() => {
    //  const dataFormat = (data) => {
    console.log(article, 'data')
    if (article?.created_at) {
      const date = new Date(article?.created_at);
      const formattedDate = new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
      }).format(date);
      setDataFormt(formattedDate)
    }

  }, [article]);

  const getYouTubeVideoId = (url) => {
    const regExp = /(?:youtube\.com\/(?:[^\/\n\s]+\/\S+\/|(?:v|e(?:mbed)?)\/|\S+\/?)(?:[^\w\-\/\?=]+(\w+)\S*)|youtu\.be\/(\w+))/;
    console.log(url, 'url')
    const match = url?.match(regExp);
    return match && (match[1] || match[2]);
  };

  return (
    <div>
      <Suspense >
        <Seo
          title={article?.title}
          description={article?.resume}
          keywords={article?.key_words}
          image={article?.image_capa}
           url={currentUrl}
          type="website"
        />
      </Suspense>
      <MenuPrincipal />
      <div className={`box-2 loading ${loading ? 'loading-active' : ''}`}>
        <LoadingOverlay loading={loading} />
        <div className="section-spacing-6">
          <Container>
            <div className="saiba-mais-container shadow-lg  bg-body rounded">
              {/* Header */}
              <header className="d-flex justify-content-center align-items-center">
                <h1 className="saiba-mais-title">{article?.title}</h1>
              </header>
              {/* Metadados */}
              <div className="text-titulo mb-4">
                <p>
                  Por <strong>{article?.autor}</strong> | <strong>{dataFormat} </strong>| Leitura:{" "}
                  <strong>5 min</strong>
                </p>
              </div>

              {/* Conteúdo com layout flexível */}
              <div className="saiba-mais-content">
                <div className="media-container">
                  {article?.video && article.video !== 'undefined' && article.video.trim() !== '' ? (
                    <div className="media-frame">
                      <iframe
                        width="100%"
                        height="315"
                        src={`https://www.youtube.com/embed/${getYouTubeVideoId(article?.video)}`}
                        title="Vídeo do YouTube"
                        frameBorder="0"
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                      ></iframe>
                    </div>
                  ) : (
                    <div className="image-frame">
                      <img
                        src={`${BASE_URL}storage/${article?.image}`} // Imagem padrão caso `image` seja nula
                        alt={article?.title || 'Imagem do artigo'}
                        className="responsive-image"
                      />
                    </div>
                  )}
                </div>
                <div className="text-content">
                  <div id="post-content" dangerouslySetInnerHTML={{ __html: article?.content }} />
                </div>
              </div>
              {/* Tags */}
              <div className="saiba-mais-tags tag-container mb-4">
                {article?.tags
                  ?.split(';') // Divide a string por ';'
                  .map((tag) => tag.trim()) // Remove espaços extras de cada tag
                  .filter((tag) => tag) // Remove strings vazias
                  .map((tag, index) => (
                    <p key={index} className="badge">
                      {tag}
                    </p>
                  ))}
              </div>
              {/* Posts Relacionados */}
              {/*{article?.related_posts?.length >= 3 && (
                <section className="section-spacing">
                  <BlogSection
                    title="Blog"
                    articles={article.related_posts}
                    settings={settingsBlog}
                    titulo="Tópicos relacionados"
                    size="card-config-2"
                    link={2}
                  />
                </section>
              )}*/}
              <div className="tag-container-2">
                <p className='badge'><i class="fa-solid fa-tag pl-3"></i> {article?.category.name}</p>
              </div>
            </div>
          </Container>
        </div>
      </div>
      <Rodape />
      <WhatsApp classe={'whatsapp-componente-flutuante'} />
    </div>
  );
};

export default Blog;
